// Country data for the African footprint.
// Each country lists a short program description + year(s) when known.
// `name` MUST match the property used by world-atlas TopoJSON (`properties.name`).
export const COUNTRIES = [
  {
    code: "ZA",
    name: "South Africa",
    flag: "🇿🇦",
    yearsLabel: "1990s–present",
    program: "Enterprise ICT, ECM & secure documents",
    summary:
      "Three decades of programs across South African government and Tier-1 enterprises — Documentum & aXcess deployments at FNB, ABSA, UNISA, SARS, Telkom, Post Office, Health Professions Council, Departments of Justice, Labour, Transport, Communications, Correctional Services, SAPS, NHBRC, SANDF and more.",
  },
  {
    code: "CD",
    name: "Dem. Rep. Congo",
    headquartered: true,
    flag: "🇨🇩",
    yearsLabel: "1990s–present",
    program: "Headquarters · Civil identity, electoral & SIMP",
    summary:
      "Home of the company and the founder. Long-running involvement in voter registration, civil registration modernisation and roll-out of the Integrated Multi-Sectoral Permanent System (SIMP) across multiple ministries.",
  },
  {
    code: "CI",
    name: "Côte d'Ivoire",
    flag: "🇨🇮",
    yearsLabel: "Multiple cycles",
    program: "Electoral systems · voter management",
    summary:
      "Support to electoral cycles with voter registration, polling logistics technology and results-aggregation systems aligned with international audit standards.",
  },
  {
    code: "MG",
    name: "Madagascar",
    flag: "🇲🇬",
    yearsLabel: "Electoral cycles",
    program: "Electoral systems",
    summary:
      "Delivery partner for electoral information systems and identification document personalisation across multiple national cycles.",
  },
  {
    code: "GN",
    name: "Guinea",
    flag: "🇬🇳",
    yearsLabel: "Electoral cycles",
    program: "Electoral systems · voter rolls",
    summary:
      "Voter roll modernisation and election-day data acquisition platforms, with audit-ready transparency layers.",
  },
  {
    code: "ML",
    name: "Mali",
    flag: "🇲🇱",
    yearsLabel: "Electoral cycles",
    program: "Electoral systems",
    summary:
      "Field deployment of polling-station technology and centralised results aggregation.",
  },
  {
    code: "BF",
    name: "Burkina Faso",
    flag: "🇧🇫",
    yearsLabel: "Electoral cycles",
    program: "Electoral systems",
    summary:
      "Support to voter registration drives and election results infrastructure.",
  },
  {
    code: "NE",
    name: "Niger",
    flag: "🇳🇪",
    yearsLabel: "Electoral cycles",
    program: "Electoral systems",
    summary:
      "Electoral information systems and identity document programs.",
  },
  {
    code: "TG",
    name: "Togo",
    flag: "🇹🇬",
    yearsLabel: "Electoral cycles",
    program: "Electoral systems",
    summary:
      "Voter registration and result-collection platforms.",
  },
  {
    code: "SN",
    name: "Senegal",
    flag: "🇸🇳",
    yearsLabel: "Electoral cycles",
    program: "Electoral systems · identity",
    summary:
      "Electoral programs and contribution to secure identity document personalisation.",
  },
  {
    code: "TD",
    name: "Chad",
    flag: "🇹🇩",
    yearsLabel: "Electoral cycles",
    program: "Electoral systems",
    summary:
      "Voter management infrastructure and field deployment teams.",
  },
  {
    code: "KM",
    name: "Comoros",
    flag: "🇰🇲",
    yearsLabel: "Electoral cycles",
    program: "Electoral systems",
    summary:
      "Smaller-scale electoral programs adapted to island logistics.",
  },
  {
    code: "CM",
    name: "Cameroon",
    flag: "🇨🇲",
    yearsLabel: "Electoral cycles",
    program: "Electoral & identity programs",
    summary:
      "Electoral systems and identity document personalisation programs.",
  },
];

export const SERVED_NAMES = new Set(COUNTRIES.map((c) => c.name));
